import React              from 'react';

function DisplayStatusDXYBox( { key, rec } ) {

    return(<> 
             { rec ? (<div className={'dxybox-state ' + 'dxybox-status-' + ( rec.mz !== true ? 'none' : ( rec.sc > 0.99 ? 'green' : (rec.sc > 0.67 ? 'amber' : 'red'))) }>&nbsp;</div> ) : (<>Loading...</>) }
           </>);
}

export default DisplayStatusDXYBox;
